var ___CARDJS_BACKUPS = {
	Payment: window.Payment
};

define('card-patched',[
	"card"
], function(
) {
	var Card = window.Card;

	window.Payment = ___CARDJS_BACKUPS.Payment;

	delete ___CARDJS_BACKUPS;

	return Card;
});
